import * as React from 'react'
import { IRiderObject, IStateMetadata } from '../../../types'
import { Elements, StripeProvider } from 'react-stripe-elements'
import PaymentSourceList from './PaymentSourceList'
import AddCardForm from './AddCardForm'
import FloatingForm from 'src/components/ui/form/FloatingForm'

interface IWalletPaneFormProps {
  metadata: IStateMetadata
  rider: IRiderObject
  addRiderPaymentSource: (stripeToken: string, riderId: string) => Promise<any>
  removeRiderPaymentSource: (paymentSourceId: string, riderId: string) => Promise<any>
  updateDefaultPaymentSource: (paymentSourceId: string, riderId: string) => Promise<any>
}

class WalletPaneForm extends React.Component<IWalletPaneFormProps> {
  constructor(props: any) {
    super(props)
  }

  public render() {
    const { rider } = this.props

    if (!rider) {
      return null
    }

    const isSaving = this.props.metadata.fetching
    const bodyStyle: any = {
      pointerEvents: isSaving ? 'none' : 'auto',
      opacity: isSaving ? 0.4 : 1.0
    }
    const cardFormProps = {
      rider,
      addRiderPaymentSource: this.props.addRiderPaymentSource,
      metadata: this.props.metadata
    }
    const paymentSourceListProps = {
      riderId: rider.id,
      paymentSources: rider.wallet ? rider.wallet.sources : [],
      removeRiderPaymentSource: this.props.removeRiderPaymentSource,
      updateDefaultPaymentSource: this.props.updateDefaultPaymentSource
    }
    const key =
      process.env.REACT_APP_ENV === 'production'
        ? process.env.REACT_APP_STRIPE_KEY_PROD || ''
        : process.env.REACT_APP_STRIPE_KEY_TEST || ''
    console.log('using stripe key: ', key)
    return (
      <StripeProvider apiKey={key}>
        <section>
          <FloatingForm fullHeight={true}>
            <div className='form-modal-section full-section'>
              <div className='flex ml3'>
                <Elements>
                  <AddCardForm {...cardFormProps} />
                </Elements>
                <PaymentSourceList {...paymentSourceListProps} />
              </div>
            </div>
          </FloatingForm>
          {this.props.children}
        </section>
      </StripeProvider>
    )
  }
}

export default WalletPaneForm



// WEBPACK FOOTER //
// ./src/components/riders/common/WalletPaneForm.tsx